import React from 'react';
import { Link } from 'react-router-dom';
import { isNull, startCase } from 'lodash';
import moment from 'moment-timezone';
import ReactTooltip from 'react-tooltip';
import { useStoreActions } from 'easy-peasy';

const format1 = 'YYYY-MM-DD';
const format2 = 'lll';

const DealDateTime = ({ dateTime, format }) => moment(dateTime).format(format);

const DealList = ({ deal }) => {
  const { setDefaultPlaceId } = useStoreActions(state => state.menu);

  React.useEffect(() => {
    console.log('setting timezone timezonetimezone = ', deal?.place?.timezone);
    if (deal?.place?.timezone) {
      moment.tz.setDefault(deal?.place?.timezone);
    }
  }, [deal?.place?.timezone]);

  return (
    <tr>
      <td>
        <Link
          onClick={() => setDefaultPlaceId(deal.place_id)}
          to={`/update-place-deal/${deal.place.place_id}/${deal.deal_id}`}
        >
          {deal.name}
        </Link>
      </td>
      <td>{startCase(deal.deal_type)}</td>
      <td>{startCase(deal.promotion)}</td>
      <td>{deal.promo_code}</td>
      <td>{deal.service_type}</td>
      <td>{deal.menu === null ? '' : deal.menu.name}</td>
      <td>{deal.place.name}</td>
      <td>{deal.place.city}</td>
      <td>
        {isNull(deal.start) ? (
          'N.A'
        ) : (
          <DealDateTime dateTime={deal.start} format={format1} />
        )}
      </td>
      <td>
        {isNull(deal.end) ? (
          'N.A'
        ) : (
          <DealDateTime dateTime={deal.end} format={format1} />
        )}
      </td>
      <td>
        <ReactTooltip html place="top" type="dark" effect="float" />
        <p
          data-tip={`<span>
          <p>email: ${deal.updated_by_user.email}</p>
          <p>objectId: ${deal.updated_by_user.user_id}</p>
        </span>`}
          data-html
        >
          {deal.updated_by_user.display_name}
        </p>
      </td>
      <td>
        <DealDateTime dateTime={deal?.audit?.updated_at} format={format2} />
      </td>
      <td>
        <Link>
          <i className="fas fa-trash has-text-grey" />
        </Link>
      </td>
    </tr>
  );
};

export default DealList;
